import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  &.insight-details-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: stretch;

    @media (min-width: 992px) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  &.insights_imagecard {
    display: block;
  }

  &.html-container {
    background-color: #fff;

    p + ul {
      position: relative;
      top: -10px;
    }

    ul,
    ol,
    p {
      line-height: 1.5;
      color: #777;
      font-family: inherit;
      margin-bottom: 1rem;

      a {
        color: inherit;
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }
    }

    ul,
    ol {
      margin-bottom: 1rem;

      li {
        padding-top: 4px;
        padding-bottom: 4px;

        &:last-child {
          padding-bottom: 0;
        }
      }
    }

    ul {
      list-style: disc;
      ul {
        &:last-child {
          margin-bottom: 0;
        }
        list-style: circle;
        ul {
          list-style: square;
        }
      }
    }

    h4 {
      line-height: 1.6;
      color: #777;
      font-size: 18px;
      font-weight: 400;
      padding-top: 5px;
      margin: 0 0 1rem;
    }

    h3 {
      @media (max-width: 1199.98px) {
        font-size: 18px;
      }
      @media (max-width: 767.98px) {
        font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
        margin-bottom: 1rem;
      }
    }

    p[color='red'] {
      a {
        &:focus {
          color: #ce445b;
        }
      }
    }

    &[dir='ltr'] {
      h4 {
        font-family: 'LibreBaskervilleRegular';
      }

      ul,
      ol {
        padding-left: 25px;
      }
    }

    &[dir='rtl'] {
      h4 {
        font-family: GEAwtarDWTCMedium, sans-serif;
      }

      ul,
      ol {
        padding-right: 25px;
      }
    }

    @media (min-width: 1200px) {
      padding: 5rem 15px;
    }

    @media (max-width: 1199px) {
      padding: 50px 15px;
    }

    @media (max-width: 991px) {
      padding: 0 15px 3rem;
      padding-top: 50px;
    }
    @media (max-width: 575.98px) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 720px;
  }

  @media (min-width: 992px) {
    max-width: 960px;
  }

  @media (min-width: 1100px) {
    max-width: 1100px;
  }

  @media (min-width: 1280px) {
    max-width: 1220px;
  }

  @media (max-width: 575.98px) {
    padding: 0px 30px;
  }

  &.padding-lr-zero {
    padding-left: 0px;
    padding-right: 0px;
  }

  &.zeropadding_responsive {
    @media (max-width: 575.98px) {
      padding-right: 0px;
      padding-left: 0px;
    }
  }
    
  &.free_zonecta {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
    .btn_breadcrumn {
      @media (min-width: 768px) {
        text-align: right !important;
      }
    }
  }

  .row {
    .col {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;

      position: relative;
      width: 100%;
      min-height: 1px;
      padding-right: 15px;
      padding-left: 15px;
    }
  }
`;
